import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { CustomerProfile, Promotion } from '@/models';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';
import { CountryCode, Modals } from '@/store/ui';

@Component({
  name: 'CmgLoyaltyPepper',
})
export default class CmgLoyaltyPepper extends Vue {
  @Prop({ required: true, type: Array })
  promotions!: Promotion[];

  @Prop({ default: false, type: Boolean })
  disabled!: boolean;

  onClickPepper() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsLanding,
      action: AnalyticsEventAction.MobileScan,
      label: AnalyticsEventLabel.MobileScan,
    });

    let modalName: keyof Modals = this.isLoyaltyAvailable || this.hasPromotions
      ? 'rewards'
      : 'giftCardQr';
    this.$services.ui.setModalVisibility(modalName, true);
  }

  get badgeIconUrl(): string {
    return this.$appStore.state.cms.images.icons.qrCode.default;
  }

  get isDoubleDigits(): boolean {
    return this.promotions.length > 9;
  }

  get customer(): CustomerProfile | null {
    return this.$appStore.state.customer.profile;
  }
  
  get isLoggedIn(): boolean {
    return this.$services.customer.isLoggedIn() === true;
  }

  get isGiftCardEnabled(): boolean {
    // TODO: Possibly use countries configuration in constants.ts to drive specific functionality availability and avoid hardcoded country code checks
    return this.$appStore.state.ui.countryProfile.countryCode === CountryCode.US;
  }

  get shouldShowLoyaltyPepper(): boolean {
    if (!this.isLoggedIn || !this.customer) {
      return false;
    }

    return this.isLoyaltyAvailable ||
      this.hasValidGiftCard ||
      this.hasPromotions;
  }

  get isLoyaltyAvailable(): boolean {
    return !this.$appStore.state.reward.unreachable && this.$services.loyalty.isLoyaltyEligible(this.customer);
  }

  get hasValidGiftCard(): boolean {
    return this.isGiftCardEnabled && this.$appStore.state.customer.wallet.paymentCards.some(card => card.isGiftCard);
  }

  get hasPromotions(): boolean {
    return this.$appStore.state.customer.wallet.promotions.length > 0;
  }
}
